require.register("app/order/delivery/ShowView", function(exports, require, module){
  $0
  
});

